<template>
  <b-modal id="pastExperiencesModal" size="lg" centered modal-class="quote-modal" no-stacking no-close-on-backdrop hide-footer>
    <template #modal-header="{ close }">
      <div class="modal-close-button">
        <b-button variant="close-button" title="Close modal pop up" @click="close()"></b-button>
      </div>
    </template>
    <b-row no-gutters>
      <b-col lg="4" class="align-self-end text-center order-lg-1 order-2 col-8 offset-lg-0 offset-2">
        <div class="img-wrap">
          <img class="img-fluid" src="../../images/helpingfamilyfriends/past-experience.png" alt="Photo of a young woman looking concerned" />
        </div>
      </b-col>

      <b-col lg="8" class="align-self-center order-lg-2 order-1">
        <h3 class="modal-title mb-4" id="pastExperiencesModalLabel">Past experiences</h3>

        <p class="quote-text">After my mum’s experience, I don’t want to know.</p>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: "PastExperiences",
};
</script>
